module.exports = __webpack_public_path__ + "img/6.2ca2ec58.png";